import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { AvailableTimes as MuiAvailableTimes } from '../styled';
import { useScheduleAvailableTimeGroupedByPeriod } from '../hooks';
import { formatPeriodLabel, formatTimeLabel } from '../../../../lib/dayjs';
import { saveSelectedDate } from '../../../../features/schedule/schedule-slice';
import { RootState } from '../../../../store';
import { customEventTracking } from '../../../../lib/gtm';
import { ChilHourLabel, ChipHour, ChipList } from './style';
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { IAppointments } from '../../../../services/availableTimes.service';
import Button from '@mui/material/Button';
interface AvailableTimesProps {
  appointments: IAppointments;
  isLoading: boolean;
}

const AvailableTimes = ({ appointments, isLoading }: AvailableTimesProps) => {
  const dispatch = useDispatch();
  const {
    schedule: { selectedDay, dateStart, events }
  } = useSelector((state: RootState) => state);
  const [scheduleAvailableTimeGroupedByPeriod] = useScheduleAvailableTimeGroupedByPeriod(appointments, selectedDay);
  const [viewMore, setViewMore] = useState<{
    [key: string]: boolean;
  }>({ morning: false, afternoon: false, evening: false });

  useEffect(() => {
    const timer = setTimeout(() => {
      customEventTracking.send({
        event: events,
        props: {
          day_available: selectedDay,
          available_times: `morning: ${
            scheduleAvailableTimeGroupedByPeriod?.morning?.availableList.length > 0 ? true : false
          }, afternoon: ${
            scheduleAvailableTimeGroupedByPeriod?.afternoon?.availableList.length > 0 ? true : false
          }, evening: ${scheduleAvailableTimeGroupedByPeriod?.evening?.availableList.length > 0 ? true : false}`
        }
      });
    }, 1000);
    return () => clearTimeout(timer);
  }, [scheduleAvailableTimeGroupedByPeriod, events]);
  return (
    <MuiAvailableTimes>
      {!isLoading ? <></> : <CircularProgress sx={{ color: 'brand.darkGreen' }} />}
      <>
        {Object.keys(scheduleAvailableTimeGroupedByPeriod).map((key, index) => {
          return (
            scheduleAvailableTimeGroupedByPeriod[key].availableList.length >= 1 && (
              <Box key={index} sx={{ marginBottom: { xs: '24px', md: '30px' } }}>
                <ChilHourLabel variant="body2R">{formatPeriodLabel(key)}</ChilHourLabel>
                <ChipList>
                  {scheduleAvailableTimeGroupedByPeriod[key].availableList.map((value, index) => {
                    return (
                      <ChipHour
                        key={index}
                        label={formatTimeLabel(value)}
                        variant="outlined"
                        className={`${value === dateStart ? 'selected' : ''} ${index > 1 && !viewMore[key] ? 'hidden' : ''}`}
                        onClick={() => {
                          dispatch(saveSelectedDate(value));
                          customEventTracking.send({
                            event: 'calendar_touch_time',
                            props: {
                              touch_time: value
                            }
                          });
                        }}
                      />
                    );
                  })}

                  {scheduleAvailableTimeGroupedByPeriod[key].availableList.length > 2 && !viewMore[key] && (
                    <Button
                      variant="inline"
                      color="primary"
                      sx={{ p: 0 }}
                      onClick={() =>
                        setViewMore(prevState => ({
                          ...prevState,
                          [key]: true
                        }))
                      }
                    >
                      ver mais
                    </Button>
                  )}
                </ChipList>
              </Box>
            )
          );
        })}
      </>
    </MuiAvailableTimes>
  );
};

export default AvailableTimes;
